import { HomeOutlined } from "@ant-design/icons";
import { Breadcrumb as BC } from "antd";
import { Link } from "react-router-dom";

interface Props {
  pathText: string;
  isProfile?: boolean;
}

export const BreadcrumbComponent: React.FC<Props> = ({
  pathText,
  isProfile,
}) => {
  const items = [
    {
      title: (
        <Link to="/">
          <HomeOutlined />
        </Link>
      ),
    },
  ];

  if (!isProfile) items.push({ title: <Link to="/users">Usuarios</Link> });

  items.push({ title: <span>{pathText}</span> });

  return <BC items={items} />;
};
